<template>
  <div class="ComInvitationlink">
    <div class="ComInvitationlink_item padding-1" :style="{ backgroundImage: `url(${ bg})` }">
  <div class="ComInvitationlink_font">{{title}}</div>
 <div class="ComInvitationlink_link padding-1 mt-1">{{url}}</div>
 <ComButton class="mt-1" @click="clickCopy">{{$t(btnLabel)}}</ComButton> 

</div>
<div class="ComInvitationlink_reference mt-1" v-if='reference_address'>
   <div class="ComInvitationlink_font">{{$t(reference_title)}}</div>
   <div class="ComInvitationlink_address padding-0">{{reference_address}}</div>
 </div>
  </div>
  
</template>

<script>
export default {
  name: "ComInvitationlink",
  props: {

    title: {
      type: String,
      default: "我的邀请链接",
    },
    url: {
      type: String,
      default: "https://rank.carbon.baby/adminweb/#/login?...",
    },
    btnLabel: {
      type: String,
      default: "复制链接邀请好友", 
    },
    bg:{
      type: String,
      default: require('@/assets/image/Miracle/personage/linkbg.png'),
    },
    reference_address:{
      type: String,
      default: "",
    },
    reference_title:{
      type: String,
      default: "我的推荐人", 
    }
  },
  data() {
    return {};
  },
  methods: {
    clickCopy() {
      this.$emit("copy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>